import React, { Component } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

class BubbleForReport extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount(){
    let chart = null;
    const data = this.props.data;
    const excelExportFunc = this.props.excelExportFunc;
    const reportType = this.props.reportType;
    const reportName = this.props.reportName;

    this.createBubbleForReport(chart, reportName, data, excelExportFunc);
  }

  componentWillUnmount(){
    if(this.chart) this.chart.dispose();
  }
  
  createBubbleForReport = (chart, reportName, dataSet, excelExportFunc) => {
    chart = am4core.create(this.reportBubbleChart, am4charts.XYChart);
    am4core.useTheme(am4themes_animated);

    // chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.data = JSON.parse(JSON.stringify(dataSet));

    let valueAxisX = chart.xAxes.push(new am4charts.ValueAxis());
    let valueAxisY = chart.yAxes.push(new am4charts.ValueAxis());

    valueAxisY.title.text = "PSR (%)";
    valueAxisY.title.fontWeight = "bold";

    const valueReducer = (accumulator, currentValue) => ({value: accumulator.value + currentValue.value});
    const psrReducer = (accumulator, currentPsr) => {
      let retAcc = parseFloat(accumulator.y);
      let retCur = parseFloat(currentPsr.y);

      if(retAcc == "NaN") retAcc = 0;
      if(retCur == "NaN") retCur = 0;

      return ({y: retAcc+retCur});
    }
    let volAvr = 0;
    let psrAvr = 0;
    if(dataSet.length != 0) {
      volAvr = dataSet.reduce(valueReducer).value / dataSet.length;
      psrAvr = dataSet.reduce(psrReducer).y / dataSet.length;
    }

    valueAxisX.title.text = `Average Buzz Volume: ${volAvr.toFixed(0)}\nAverage PSR: ${psrAvr.toFixed(2)}%`;
    valueAxisX.title.fontWeight = "bold";
    valueAxisX.title.align = "right";

    valueAxisY.min = 0;
    valueAxisY.max = 100;

    // let psrLabel = chart.createChild(am4core.Label);
    // psrLabel.text = `Average PSR: ${psrAvr.toFixed(2)}%`;
    // psrLabel.fontWeight = "bold";
    // psrLabel.x = am4core.percent(90);
    // psrLabel.y = am4core.percent(10);

    let series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueX = "x";
    series.dataFields.valueY = "y";
    series.dataFields.value = "value";
    series.strokeOpacity = 0;
    series.sequencedInterpolation = true;

    let bullet = series.bullets.push(new am4core.Circle());
    bullet.fill = am4core.color("#ff0000");
    bullet.propertyFields.fill = "color";
    bullet.strokeOpacity = 0;
    bullet.radius = 5;
    bullet.strokeWidth = 2;
    bullet.fillOpacity = 0.7;
    bullet.stroke = am4core.color("#ffffff");
    
    bullet.tooltipText = "[bold]{title}:[/]\nPSR: {valueY.value}\nBuzz Volume: {valueX.value}\nPositive:{positive.value}\nNegative:{negative.value}";

    // let hoverState = bullet.states.create("hover");
    // hoverState.properties.fillOpacity = 1;
    // hoverState.properties.strokeOpacity = 1;

    // series.heatRules.push({ target: bullet, min: 10, max: 60, property: "radius" });
    series.heatRules.push({ target: bullet, min: 15, max: 15, property: "radius" });

    // bullet.adapter.add("tooltipY", function (tooltipY, target) {
    //   return -target.radius;
    // })
    
    let valueLabel = series.bullets.push(new am4charts.LabelBullet());
    valueLabel.label.text = "{title}";
    valueLabel.label.fontSize = 15;

    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarY = new am4core.Scrollbar();

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.container = document.getElementById("export-container");
    let today = new Date();
    chart.exporting.filePrefix = `${reportName}_${today.toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`;
    chart.exporting.useWebFonts = false;
    chart.exporting.menu.items = [
      {
        "label": "...",
        "menu": [
          {
            "type": "png",
            "label": "PNG"
          },
          {
            "type": "jpg",
            "label": "JPG"
          },
          {
            "type": "custom",
            "label": "Excel",
            "options": {
              callback: excelExportFunc
            }
          }
        ]
      }
    ]

    this.chart = chart;
  }

  render() {
    return(
      <div>
        <div id="export-container" style={{position:"relative", minHeight:"30px"}}/>
        <div id="report-bubble" ref={ref=>(this.reportBubbleChart=ref)} style={{ width: this.props.width, height: this.props.height }}></div>
      </div>
    )
  }
}

export default BubbleForReport;